import { apiSlice } from '../api/api-slice';
import {
    AccessTokenPayload,
    SignInRequest,
    SignInResponse,
    StaffUserSignOut,
} from 'types/staff-user/staff-user';
import { MutationLifecycleApi } from '@reduxjs/toolkit/src/query/core';
import { BaseQueryFn } from '@reduxjs/toolkit/src/query/baseQueryTypes';
import {
    logOutStaffUser,
    setStaffUser,
} from 'store/slices/staff-user/staff-user-slice';
import { jwtDecode } from 'jwt-decode';
import { StaffUserState } from 'types/staff-user/staff-user-state';

export const staffUserAuthApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        signIn: builder.mutation<SignInResponse, SignInRequest>({
            query: (signInRequest: SignInRequest) => ({
                url: '/admin/login',
                method: 'POST',
                body: { ...signInRequest },
            }),
            async onQueryStarted(
                _: SignInRequest,
                api: MutationLifecycleApi<
                    SignInRequest,
                    BaseQueryFn,
                    SignInResponse
                >,
            ): Promise<void> {
                try {
                    const { data } = await api.queryFulfilled;

                    const accessTokenData: AccessTokenPayload = jwtDecode(
                        data.accessToken,
                    );
                    const state: StaffUserState = {
                        staffUser: {
                            email: accessTokenData.admin_name,
                            status: data.userStatus,
                        },
                    };

                    localStorage.setItem(
                        'staffUser',
                        JSON.stringify({
                            ...accessTokenData,
                            status: state?.staffUser?.status,
                        }),
                    );

                    localStorage.setItem('access_token', data.accessToken);
                    localStorage.setItem('refresh_token', data.refreshToken);

                    api.dispatch(setStaffUser(state.staffUser));
                } catch (error) {
                    console.log(error);
                }
            },
        }),

        signOut: builder.mutation<void, StaffUserSignOut>({
            query: (staffUserSignOut: StaffUserSignOut) => ({
                url: '/admin/logout',
                method: 'PATCH',
                body: { ...staffUserSignOut },
            }),
            async onQueryStarted(
                _: StaffUserSignOut,
                api: MutationLifecycleApi<StaffUserSignOut, BaseQueryFn, void>,
            ): Promise<void> {
                try {
                    await api.queryFulfilled;

                    localStorage.removeItem('staffUser');
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refresh_token');

                    api.dispatch(logOutStaffUser());
                    //api.dispatch(apiSlice.util.resetApiState());
                } catch (error) {}
            },
        }),
    }),
});
export const { useSignInMutation, useSignOutMutation } = staffUserAuthApi;
